'use client';

import { c as _c } from "react/compiler-runtime";
import { AppImage } from '@/app/components/media/app-image';
import styles from '@/app/lcv/components/sections/spartan/products/hero-banner/media/parallax-scene/layout.module.css';
import type { SpartanProductHeroBannerSpecialLogoSceneProps } from '@/app/lcv/components/sections/spartan/products/hero-banner/media/parallax-scene/special-logo/types';
import { SPARTAN_PRODUCT_HERO_BANNER_TRACKING } from '@/app/lcv/components/sections/spartan/products/hero-banner/tracking';
import { getSpartanProductHeroBannerSpecialLogoSceneLayoutStyle, getSpartanProductHeroBannerSpecialLogoSizes } from '@/app/lcv/components/sections/spartan/products/hero-banner/utils/scene-layout';
import { cn } from '@/app/utils/cn';
export const SpartanProductHeroBannerSpecialLogoScene = t0 => {
  const $ = _c(16);
  const {
    title,
    specialLogo,
    scene
  } = t0;
  if (!specialLogo) {
    return null;
  }
  let t1;
  if ($[0] !== scene || $[1] !== specialLogo.scene) {
    t1 = getSpartanProductHeroBannerSpecialLogoSceneLayoutStyle(scene, specialLogo.scene);
    $[0] = scene;
    $[1] = specialLogo.scene;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  let t2;
  if ($[3] !== scene || $[4] !== specialLogo.scene) {
    t2 = getSpartanProductHeroBannerSpecialLogoSizes(scene, specialLogo.scene);
    $[3] = scene;
    $[4] = specialLogo.scene;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const sizes = t2;
  let t3;
  if ($[6] !== specialLogo.className) {
    t3 = cn(styles.specialLogoScene, styles.engineLogoReveal, specialLogo.className);
    $[6] = specialLogo.className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== sizes || $[9] !== specialLogo.src || $[10] !== title) {
    t4 = <div className={styles.specialLogoSceneMedia}><AppImage src={specialLogo.src} alt={title} fill={true} sizes={sizes} objectFit="contain" fade={false} loading="eager" testId={SPARTAN_PRODUCT_HERO_BANNER_TRACKING.specialLogo} /></div>;
    $[8] = sizes;
    $[9] = specialLogo.src;
    $[10] = title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== style || $[13] !== t3 || $[14] !== t4) {
    t5 = <div aria-hidden="true" className={t3} style={style}>{t4}</div>;
    $[12] = style;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};